import React from "react";
import "../../styles/index.scss";
import ItemAgreement from "../ItemAgreement";
import { changeCurrancyFormat, decode_utf8, getPageLayoutType } from "../../../../common/utils/utilsFunc";
import FileUploaded from "../../../../common/components/FileUploader";
import { CGE } from '../../../../common/components/CGE';
import { useModal } from "@clayui/modal";
import AlertModal from "../../../../common/components/AlertModal";
import classNames from 'classnames'

const SecondStep = ({ props }) => {

    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        }
    });

    React.useEffect(() => {
        if (props.clienteAfectado) {
            setVisibleModal(true);
        }
    }, []);


    const {
        isSpecialOffer = false,
        piePct,
        setPiePct,
        specialOffer,
        speValorCuota = 0,
        onSpecialCuotasChange
    } = props || {};

    const SPECIAL_CUOTAS = [1, 2, 3, 4, 5, 6];


    const [localCuotas, setLocalCuotas] = React.useState(props?.valueCoute || 0);
    const [localPiePct, setLocalPiePct] = React.useState(
        typeof piePct === "number" ? piePct : 20
    );


    React.useEffect(() => {
        if (typeof piePct === "number") setLocalPiePct(piePct);
    }, [piePct]);


    const se_montoAdeudado = isSpecialOffer ? Number(specialOffer?.monto || 0) : 0;
    const se_pieMonto = Math.round(se_montoAdeudado * (localPiePct / 100));


    let optionsCuota = [{ label: "[Seleccione Cuota]", value: 0 }];
    if (isSpecialOffer) {
        SPECIAL_CUOTAS.forEach((n) => optionsCuota.push({ label: n, value: n }));
    } else if (props?.cuotasNumber) {
        props?.cuotasNumber.forEach((n) => optionsCuota.push({ label: n, value: n }));
    }


    const handleChangeCuotas = ({ target }) => {
        const v = Number(target.value || 0);
        if (isSpecialOffer) {
            setLocalCuotas(v);
            onSpecialCuotasChange && onSpecialCuotasChange(v);
        } else {
            props.funcClick && props.funcClick(v);
        }
    };


    const handleChangePie = ({ target }) => {
        const v = Number(target.value || 0);
        setLocalPiePct(v);
        setPiePct && setPiePct(v);
        setLocalCuotas(0);
        props.setValueCoute && props.setValueCoute("");

    };

    return (
        <div id="container" className="bg-white">
            <div className="row resp-mx-auto align-items-center">
                <div
                    className={classNames({
                        'col-md-12 resp-pl-0': getPageLayoutType(),
                        'col-md-12 align-items-center container-fluid container-fluid-max-md padding-number-installments ': !getPageLayoutType()
                    })}
                >
                    <CGE.Spacing type="nl" />
                    {isSpecialOffer && (
                        <>
                            <CGE.FormsField
                                horizontal
                                labelName="Pie (%)"
                                idFormElement="piePct"
                                typeFormElement="text"
                                typeElement="select"
                                listOptions={[
                                    { label: "[Seleccione Pie]", value: 0 },
                                    20, 30, 40, 50, 60, 70, 80
                                ].map(v => (typeof v === "number" ? { label: `${v}%`, value: v } : v))}
                                placeholder="Seleccione el porcentaje de pie"
                                value={localPiePct || 0}
                                handleChange={handleChangePie}
                            />
                            <CGE.Spacing type="nl" />
                        </>
                    )}

                    <CGE.FormsField
                        horizontal
                        labelName="N° de cuotas"
                        handleChange={handleChangeCuotas}
                        idFormElement="numberCuotas"
                        typeFormElement="text"
                        mandatoryElement
                        typeElement="select"
                        listOptions={optionsCuota}
                        placeholder="Seleccione el número de cuotas"
                        value={isSpecialOffer ? (localCuotas || 0) : (props?.valueCoute)}
                        hasError={props.inputFileValidate && !((isSpecialOffer ? localCuotas : props.valueCoute))}
                        atcRef={props.refCuota}
                    />
                </div>

                <div className="col-md-12 text-center my-4 py-2">
                    <CGE.Heading className="next-step-title" text="Resumen de Convenio" size="4" />
                </div>

                {/* Monto Adeudado */}
                <ItemAgreement
                    label="Monto Adeudado"
                    value={
                        isSpecialOffer
                            ? changeCurrancyFormat(se_montoAdeudado)
                            : (props.montoAdeudado ? changeCurrancyFormat(props.montoAdeudado) : "$ 0.00")
                    }
                />

                {/* Pie de convenio */}
                <ItemAgreement
                    label="Pie de convenio"
                    value={
                        isSpecialOffer
                            ? changeCurrancyFormat(se_pieMonto)
                            : (props.pieConvenio ? changeCurrancyFormat(props.pieConvenio) : "$ 0.00")
                    }
                />

                {/* Tasa de Interés anual */}
                <ItemAgreement
                    label="Tasa de Interés anual"
                    value={
                        isSpecialOffer
                            ? "0 %"
                            : (props.tasaInteres ? props.tasaInteres : "0.00 %")
                    }
                />

                {/* N°Cuotas */}
                <ItemAgreement
                    label="N°Cuotas"
                    value={
                        isSpecialOffer
                            ? (localCuotas || "")
                            : (props.cuotaValue ? props.cuotaValue : "")
                    }
                />

                {/* Monto Cuota */}
                <ItemAgreement
                    label="Monto Cuota"
                    value={
                        isSpecialOffer
                            ? changeCurrancyFormat(localCuotas ? (speValorCuota || 0) : 0)
                            : (props.montoCuota ? changeCurrancyFormat(props.montoCuota) : "$ 0.00")
                    }
                    description="*Monto de cuota referencial"
                />

                {/* Documentos (igual que antes) */}
                {props.showDocuments && (
                    <>
                        <div className="col-md-12 mt-4">
                            <b>{props?.titulo_superior_detalles_archivo !== "null" && props?.titulo_superior_detalles_archivo}</b>
                        </div>
                        <CGE.Spacing type="nl" />
                        <div className="col-md-12 mt-2">
                            <FileUploaded
                                idInput="identidad"
                                labelInput="Carnet de identidad por ambos lados:"
                                deleteFile={() => props.setSelectedFile({ ...props.selectedFile, identidad: null })}
                                onFileSelectSuccess={(file) => props.setSelectedFile({ ...props.selectedFile, identidad: file })}
                                properties
                                setErroUploadFile={props.setErroUploadFile}
                                dataProps={props.properties}
                                maxFileSize={props.properties?.tamano_maximo_de_archivo_MB}
                                typeFile={props?.properties?.documento_extension}
                                msgErrorFileSize={decode_utf8(props?.properties?.erro_documento_tamano)}
                                mandatoryElement
                                hasError={props.inputFileValidate && !props.selectedFile?.identidad}
                                msgError="Debes adjuntar el carnet de identidad por ambos lados"
                            />
                            <FileUploaded
                                idInput="poderNotarial"
                                labelInput="Si es arrendatario, Poder notarial donde dueño autoriza generación de convenio:"
                                deleteFile={() => props.setSelectedFile({ ...props.selectedFile, poderNotarial: null })}
                                onFileSelectSuccess={(file) => props.setSelectedFile({ ...props.selectedFile, poderNotarial: file })}
                                properties
                                setErroUploadFile={props.setErroUploadFile}
                                dataProps={props.properties}
                                maxFileSize={props.properties?.tamano_maximo_de_archivo_MB}
                                typeFile={props?.properties?.documento_extension}
                                msgErrorFileSize={decode_utf8(props?.properties?.erro_documento_tamano)}
                            />
                            <FileUploaded
                                idInput="dominioVigente"
                                labelInput="Dominio vigente de la propiedad:"
                                mandatoryElement
                                deleteFile={() => props.setSelectedFile({ ...props.selectedFile, dominioVigente: null })}
                                onFileSelectSuccess={(file) => props.setSelectedFile({ ...props.selectedFile, dominioVigente: file })}
                                properties
                                setErroUploadFile={props.setErroUploadFile}
                                dataProps={props.properties}
                                maxFileSize={props.properties?.tamano_maximo_de_archivo_MB}
                                typeFile={props?.properties?.documento_extension}
                                msgErrorFileSize={decode_utf8(props?.properties?.erro_documento_tamano)}
                                hasError={props.inputFileValidate && !props.selectedFile?.dominioVigente}
                                msgError="Debes adjuntar el dominio vigente de la propiedad"
                            />
                        </div>
                    </>
                )}
            </div>

            {visibleModal && (
                <AlertModal
                    titleModal="Información relevante"
                    msgModal={
                        "Estimado cliente, dado que usted ha sido uno de los damnificados por los incendios que afectaron a la región de Valparaíso, queremos comunicarle que no es posible generar un convenio de pago por este medio. Al ser usted beneficiario de condiciones especiales para la renegociación de su deuda, le recomendamos acercarse a su oficina comercial más cercana."
                    }
                    observer={observer}
                    onClose={onClose}
                    status="info"
                />
            )}
        </div>
    );
};

export default SecondStep;